import type { GeoPoint, Stage } from '@api/types'

// Recorrer el Camino etapa a etapa en el mapa (funciones puras).

// Las etapas en el orden del Camino (la API no garantiza el orden de la lista).
export const sortStages = (stages: readonly Stage[]): Stage[] => [...stages].sort((a, b) => a.order - b.order)

export type StagePosition = { stage: Stage; total: number; prev: Stage | null; next: Stage | null }

// Una etapa con cuántas hay, la anterior y la siguiente; null si no está.
export const stagePosition = (sorted: readonly Stage[], id: string | null): StagePosition | null => {
	const index = id === null ? -1 : sorted.findIndex((stage) => stage.id === id)
	const stage = sorted[index]
	if (!stage) return null
	return {
		stage,
		total: sorted.length,
		prev: sorted[index - 1] ?? null,
		next: sorted[index + 1] ?? null,
	}
}

// Cuántos elementos (árboles, lugares) son de la etapa.
export const countInStage = (items: readonly { stageId: string | null }[], stageId: string): number =>
	items.reduce((n, item) => (item.stageId === stageId ? n + 1 : n), 0)

// Los elementos de la etapa; sin etapa (null), todos.
export const inStage = <T extends { stageId: string | null }>(items: T[], stageId: string | null): T[] =>
	stageId === null ? items : items.filter((item) => item.stageId === stageId)

// Punto de salida de la etapa (primer punto de su trazado); null si no tiene trazado.
export const stageStart = (stage: Stage): GeoPoint | null => {
	const first = stage.track.coordinates[0]
	return first ? { longitude: first[0], latitude: first[1] } : null
}
